let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("ezP1Z")]).then(() => parcelRequire('fOl4O'));